import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../../../material.module';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [RouterModule, MaterialModule],
  templateUrl: './unauthorized.component.html',
})
export class AppUnauthorizedComponent {

  constructor(
    private router: Router
  ) { }

  backToLogin() {
    localStorage.removeItem('BearerToken');
    this.router.navigate(['/authentication/login']);
  }
}
